import React from "react"
import { RotatingLines } from "react-loader-spinner"

interface Props {
    children: React.ReactNode
    loading?: boolean
    className?: string
    onClick?: any
    loadingType?: "text" | "circular"
    outlined?: boolean
    buttonType?: "submit" | "button"
    disable?: boolean
}

const LoadingButton = ({
    children,
    loading,
    className,
    onClick,
    loadingType = "text",
    outlined = false,
    buttonType = "submit",
    disable = false,
}: Props) => {
    return (
        <button
            className={`
        rounded-md 
        flex justify-center items-center cursor-pointer  
        text-xs sm:text-sm md:text-base lg:text-lg 
        px-3 py-2 sm:px-4 sm:py-2.5 md:px-6 md:py-3 
        ${
            disable
                ? `bg-gray-500`
                : `bg-primaryOrange
          shadow-[0_10px_30px_-12px_rgba(255,165,0,0.6)]
          `
        } text-white 
        ${outlined ? "border !border-secondary !bg-[#121212]" : ""} 
        ${className}
      `}
            disabled={loading || disable}
            onClick={onClick}
            type={buttonType || "submit"}
        >
            {loading ? (
                <>
                    {loadingType === "text" ? (
                        <span>Loading...</span>
                    ) : (
                        <RotatingLines
                            visible={true}
                            width="20"
                            strokeWidth="3"
                            animationDuration="0.75"
                            strokeColor="white"
                        />
                    )}
                </>
            ) : (
                children
            )}
        </button>
    )
}

export default LoadingButton
